<template>
  <div class="ns-letter">
    <div class="logo"></div>

    <div class="letter-c">
      <div class="quan"></div>
      <div class="bg" id="main-letter-bg"></div>
      <!--      <div class="mt">
              <img :src="`images/title/${$t('mk')}.png`" style="vertical-align: top"/>
            </div>-->
      <div class="text" v-if="!opened">
        <img :src="`images/title/${$t('mk')}.png`" style="vertical-align: top; margin-bottom: 10px"/>
        <br/>
        {{$t("letter.from")}}
      </div>
      <a href="javascript:void(0);" :class="`btn ${local}`" v-if="!opened" @click="play" :title="$t('letter.openLetter')" id="btn"><!--<span>{{$t("letter.openLetter")}}</span>--></a>


      <div :class="`def ${showc?'show':''}`" v-if="showDefault">
        <div class="t1">
          {{$t("letter.desc")}}
        </div>
        <div class="t2">
          {{$t("office._" + countryCode.toLowerCase() + "_c")}}<br/>
          {{$t("office._" + countryCode.toLowerCase() + "_o")}}
        </div>
        <div class="flag">
          <div class="item chn"></div>
          <div v-if="countryCode.toLowerCase()!=='chn' && countryCode!==''" :class="`item ${countryCode.toLowerCase()}`"></div>
        </div>
        <!--<div class="start">
          <a href="javascript:void(0);" @click="complete" :title="$t('letter.start')"><span>{{$t("letter.start")}}</span></a>
        </div>-->
      </div>

      <div :class="`video ${showc?'show':''}`" v-if="showVideo">
        <div class="video-c">
          <video :src="videoSrc" preload="auto" controls @ended="startBg" @play="endBg" @pause="startBg"></video>
          <!--  <a href="javascript:void(0);" class="play-btn"></a>-->
        </div>
        <div class="t1">
          <div class="t1c">
            <div :class="`item ${(index===currentVideoIndex?'current':'')}`" v-for="(item,index) in currentVideos" :title='$t("office._" + item.code + "_" + item.type)'>
              <span @click="changeVideo(index)" v-html="$t('office._' + item.code + '_' + item.type)"></span>
            </div>
            <!--   <div class="item" v-for="(item,index) in currentVideos">
                 <span>{{item.path}}</span>
            </div>-->
            <!--  <div class="item">
              驻{{country}}旅游办事处
            </div>-->
          </div>
        </div>
        <div class="flag">
          <div class="item chn"></div>
          <div v-if="countryCode.toLowerCase()!=='chn' && countryCode!==''" :class="`item ${countryCode.toLowerCase()}`"></div>
        </div>
        <!--<div class="start">
          <a href="javascript:void(0);" @click="complete" :title="$t('letter.start')"><span>{{$t("letter.start")}}</span></a>
        </div>-->
      </div>

      <div class="mask" v-show="showVideo || showDefault">
        <div :class="`start ${showc?'show':''}`">
          <a href="javascript:void(0);" :class="local" @click="complete" :title="$t('letter.start')"><!--<span>{{$t("letter.start")}}</span>--></a>
        </div>
      </div>

    </div>

    <div class="operate-bar">
      <div class="item">
        <a href="javascript:void(0);" @click="reload" class="home"></a>
      </div>
      <!--<div class="item" v-if="countryLanguage.length>1">
        <a href="javascript:void(0);" class="language"></a>
        <div class="drop">
          <div class="arrow"></div>
          <div class="drop-c">
            <a href="javascript:void(0);" v-for="(item,index) in countryLanguage" @click="setLocal(item)">{{item.name}}</a>
            &lt;!&ndash;<a href="javascript:void(0);">EN</a>&ndash;&gt;
          </div>
        </div>
      </div>-->
      <!-- <div class="item">
         <a href="javascript:void(0);" class="language"></a>
         <div class="drop">
           <div class="arrow"></div>
           <div class="drop-c">
             <a href="javascript:void(0);">中文中文中文</a>
             <a href="javascript:void(0);">EN</a>
           </div>
         </div>
       </div>-->
      <!-- <div class="item">
         <a href="javascript:void(0);" :class="`music ${playing?'current':''}`" @click="openOrCloseSound"></a>
       </div>-->
    </div>
    <div class="contact global" style="bottom: 12px">

      <div class="cc">
        <transition name="fade">
          <div class="wxqr" v-show="showQr">
            <img src="../../../assets/images/qr.png" width="130" height="130"/>
            <div class="triangle"></div>
          </div>
        </transition>
        <a href="javascript:void(0);" class="wx" @mousemove="showQr=true" @mouseout="showQr=false"></a>
        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`" target="_blank" class="fa"></a>
        <a :href="`https://twitter.com/intent/tweet?text=&url=${currentUrl}`" target="_blank" class="tw"></a>
        <a :href="`https://www.linkedin.com/shareArticle?url=${currentUrl}`" target="_blank" class="ins"></a>
      </div>


      <!--<a href="javascript:void(0);" class="wx"></a>
      <a href="javascript:void(0);" class="fa"></a>
      <a href="javascript:void(0);" class="tw"></a>
      <a href="javascript:void(0);" class="ins"></a>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "main-letter",
  props: {
    country: {
      required: true,
      type: String,
      default: ''
    },
    countryCode: {
      required: true,
      type: String,
      default: ''
    },
    countryLanguage: {
      required: true,
      type: Array,
      default: []
    }
  },
  data() {
    return {
      opened: false,
      showc: false,
      showDefault: false,
      showVideo: false,
      videoSrc: '',
      showQr: false,
      currentUrl: "",
      currentVideoIndex: 0,
      currentVideos: [],
      playing: this.$helper.data.bging,
      videos: [
        //{code: 'cn', path: 'video/country/aus.mp4'}, //xxxx
        {code: 'aus', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9c00c7215285890807996496427/hUiVw8XZ55QA.mp4'}, //澳大利亚
        {code: 'bel', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/b272d0fb5285890807993353099/0lpALYejCzoA.mp4'}, //比利时
        {code: 'ben', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/b272d0745285890807993353056/5rqzgJuDeM0A.mp4'}, //贝宁
        {code: 'blr', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9db38f165285890807996507063/UBq9Sx1n0nsA.mp4'}, //白俄罗斯
        {code: 'egy', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9db3247e5285890807996506846/s2DSBRnau7wA.mp4'}, //埃及
        {code: 'esp', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9db41fd75285890807996508171/DTcMWZhsickA.mp4'}, //西班牙
        {code: 'fra', type: "c", path: 'http://1254086875.vod2.myqcloud.com/e0e86a70vodcq1254086875/df4487755285890807980357426/9Oy6oIcYvfUA.mp4'}, //法国
        {code: 'gbr', type: "o", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/932bd9fe5285890807924784973/hQN6AO5aekAA.mp4'}, //英国
        {code: 'ind', type: "o", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/932bd9da5285890807924784960/GoPdG4Am1ZgA.mp4'}, //印度.
        {code: 'isr', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/137cc94c5285890807950052284/5bAHBFeEAAsA.mp4'}, //以色列
        {code: 'kor', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/932bd11a5285890807924784744/TP8PklmP0WkA.mp4'}, //韩国
        {code: 'lka', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9c0158275285890807996497558/hc2qcZYScycA.mp4'}, //斯里兰卡
        {code: 'lva', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/b21987f45285890807993305635/PHSjF30nP9cA.mp4'}, //拉脱维亚
        {code: 'mar', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/137cc0695285890807950052056/Bxak8UxDaesA.mp4'},  //摩洛哥                 //这个视频不存在
        {code: 'mex', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9bdc84d95285890807996476007/Tn5nhN9qlrsA.mp4'}, //墨西哥
        {code: 'mng', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/137cc0285285890807950052037/SInat7WOYVUA.mp4'}, //蒙古
        {code: 'mus', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/137cbfe35285890807950052014/9YxqwDqFYc8A.mp4'}, //毛里求斯
        {code: 'mys', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/4b0f0c765285890807947406780/5QKmVhKWuesA.mp4'}, //马来西亚
        {code: 'nga', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9bdc85775285890807996476050/aAAarsiOk8sA.mp4'}, //尼日利亚
        {code: 'nzl', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9c0168805285890807996497902/DUkai7MyFqoA.mp4'}, //新西兰
        {code: 'pak', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9bdbfcfc5285890807996475128/3APZefzT6psA.mp4'}, //巴基斯坦
        /*      {code: 'rus', type: "o", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/b056d1c85285890807993288897/BXgVMS3mn54A.mp4'},*/ //莫斯科
        {code: 'rus', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/c6957b755285890807928713365/8SqOtVaA5i8A.mp4'},  //俄罗斯
        {code: 'sgp', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9c0164625285890807996497814/W7FTDG8x1CwA.mp4'}, //新加坡
        {code: 'swe', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/c6957fd95285890807928713477/Vs4KhqX3MecA.mp4'}, //瑞典
        {code: 'tha', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/c695832c5285890807928713500/i7qHNUaMl50A.mp4'}, //泰国
        {code: 'tza', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/932bd6035285890807924784897/BrKMow8XqbAA.mp4'}, //坦桑尼亚
        {code: 'vnm', type: "c", path: 'http://1254086875.vod2.myqcloud.com/71f57d8dvodgzp1254086875/9bdca7645285890807996476846/CRy3LaiItKoA.mp4'} //越南
      ]
    }
  },
  methods: {
    changeVideo(i) {
      if (i !== this.currentVideoIndex) {
        this.currentVideoIndex = i;
        this.videoSrc = this.currentVideos[i].path;
      }
    },
    startBg() {
      _czc.push(["_trackEvent", "VIDEO", "END", "", "", ""]);
      if (this.$helper.data.sound) {
        this.$helper.data.sound.paused = false;
        this.$helper.data.bging = true;
        this.playing = true;
        this.$emit("startBg");
      }
    },
    endBg() {
      _czc.push(["_trackEvent", "VIDEO", "START", "", "", ""]);
      if (this.$helper.data.sound) {
        this.$helper.data.sound.paused = true;
        this.$helper.data.bging = false;
        this.playing = false;
        this.$emit("endBg");
      }
    },
    openOrCloseSound() {
      if (this.$helper.data.sound) {
        if (this.$helper.data.bging) {
          this.$helper.data.sound.paused = true;
          this.$helper.data.bging = false;
          this.playing = false;
        } else {
          this.$helper.data.sound.paused = false;
          this.$helper.data.bging = true;
          this.playing = true;
        }
      } else {
        this.$helper.data.sound = createjs.Sound.play("bg-sound", this.$helper.data.soundProp);
        this.$helper.data.bging = true;
        this.playing = true;
      }
    },
    complete() {
      this.$emit("complete");
    },
    setLocal(item) {
      this.$i18n.locale = item.local;
    },
    show() {
      //alert(this.countryCode);
      var video = this.videos.filter((item) => {
        return item.code === this.countryCode.toLowerCase();
      });
      if (video.length > 0) {

        //先加入
        this.currentVideos = [];
        for (var i = 0; i < video.length; i++) {
          this.currentVideos.push(video[i]);
        }

        //显示video
        this.currentVideoIndex = 0;
        this.videoSrc = video[0].path;
        this.showVideo = true;
        _czc.push(["_trackEvent", "PAGE", "LETTER-VIDEO", "", "", ""]);
      } else {
        //显示默认
        this.showDefault = true;
        _czc.push(["_trackEvent", "PAGE", "LETTER-DEFAULT", "", "", ""]);
      }
      setTimeout(() => {
        this.showc = true;
      }, 150);
    },
    reload() {
      location.reload()
    }
    ,
    play() {
      _czc.push(["_trackEvent", "CLICK", "OPEN-LETTER", "", "", ""]);
      $("#main-letter-bg").get(0).addEventListener("animationend", this.show);
      $("#main-letter-bg").addClass("play").removeClass("show");
      this.opened = true;
    }
  },
  computed: {
    local: function () {
      if (this.$i18n.availableLocales.filter((item) => {
        return item === this.$i18n.locale
      }).length > 0) {
        return this.$i18n.locale;
      } else {
        return this.$i18n.fallbackLocale;
      }
    }
  },
  mounted() {

    _czc.push(["_trackEvent", "PAGE", "LETTER", "", "", ""]);

    console.log(this.countryLanguage);
    //-----------------------------
    console.log("------------------------");
    console.log(this.$helper.data.bging);
    console.log(this.playing);
    console.log("-------------------------");
    //------------
    this.currentUrl = encodeURIComponent(window.location.href);
    setTimeout(function () {
      $("#main-letter-bg").addClass("show");
    }, 500);

    setTimeout(function () {
      $("#btn").addClass("show");
    }, 1200);
  },
  destroyed() {

  }
}
</script>

<style scoped>
.contact {
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact .cc {
  position: relative;
}

.def {
  position: absolute;
  opacity: 0;
  transition-duration: 0.6s;
  top: 150px;
  width: 100%;
  height: 100%;
  background-image: url(../../../assets/images/letter/def.png);
}

.def.show {
  opacity: 1;
  top: -20px;
}

.video {
  opacity: 0;
  transition-duration: 0.6s;
  top: 150px;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(../../../assets/images/letter/bg.png);
}

.video.show {
  opacity: 1;
  top: -20px;
}

.mask {
  bottom: 0px;
  height: 395px;
  position: absolute;
  width: 100%;
  /*  height: 100%;*/
  background-position: left bottom;
  background-image: url(../../../assets/images/letter/mask.png);
}

.video .t1 {
  position: absolute;
  left: 0px;
  width: 100%;
  bottom: 365px;
  text-align: center;
  color: #bc9563;
  font-size: 13px;
  padding-left: 120px;
  padding-right: 120px;
  box-sizing: border-box;
}

.video .t1 .t1c {
  display: flex;
  /* align-items: center;*/
  justify-content: center;
}

.video .t1 .t1c .item {
  width: 50%;
}

.video .t1 .t1c .item:last-child {
  line-height: 32px;
}

.video .t1 .t1c .item span {

  line-height: 14px;
  /*padding-top: 12px;*/
  padding-bottom: 6px;
  /*  line-height: 26px;*/
  display: inline-block;
  max-width: 180px;
  /*  text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;*/
  cursor: pointer;
  border-bottom: 4px solid transparent;
}

.video .t1 .t1c .item.current span {
  border-bottom: 4px solid #bc9563;
}


.video .video-c {
  width: 510px;
  height: 287px;
  overflow: hidden;
  position: absolute;
  bottom: 443px;
  left: 76px;
  background-color: #000;
}

.video .video-c video {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: transparent;
}


.video .video-c .play-btn {
  position: absolute;
  background-image: url(../../../assets/images/letter/play.png);
  width: 101px;
  height: 101px;
  right: -18px;
  bottom: -24px;
}


.def .t1 {
  position: absolute;
  width: 100%;
  left: 0px;
  box-sizing: border-box;
  padding-left: 100px;
  padding-right: 100px;
  top: 608px;
  line-height: 1.2;
  text-align: center;
  font-size: 16px;
  color: #101d7f;
}

.def .t2 {
  position: absolute;
  width: 100%;
  left: 0px;
  line-height: 1.2;
  bottom: 362px;
  text-align: center;
  font-size: 13px;
  color: #333333;
}

.flag {
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: 315px;
  text-align: center;
}

.flag .item {
  margin-left: 4px;
  margin-right: 4px;
  width: 44px;
  height: 29px;
  background-size: 100% 100%;
  display: inline-block;
}

.flag .item.aus {
  background-image: url(../../../assets/images/flag/aus.jpg);
}

.flag .item.bel {
  background-image: url(../../../assets/images/flag/bel.jpg);
}

.flag .item.ben {
  background-image: url(../../../assets/images/flag/ben.jpg);
}

.flag .item.bgr {
  background-image: url(../../../assets/images/flag/bgr.jpg);
}

.flag .item.blr {
  background-image: url(../../../assets/images/flag/blr.jpg);
}

.flag .item.che {
  background-image: url(../../../assets/images/flag/che.jpg);
}

.flag .item.chn {
  background-image: url(../../../assets/images/flag/chn.jpg);
}

.flag .item.dnk {
  background-image: url(../../../assets/images/flag/dnk.jpg);
}

.flag .item.deu {
  background-image: url(../../../assets/images/flag/deu.jpg);
}

.flag .item.egy {
  background-image: url(../../../assets/images/flag/egy.jpg);
}

.flag .item.esp {
  background-image: url(../../../assets/images/flag/esp.jpg);
}

.flag .item.fji {
  background-image: url(../../../assets/images/flag/fji.jpg);
}

.flag .item.fra {
  background-image: url(../../../assets/images/flag/fra.jpg);
}

.flag .item.gbr {
  background-image: url(../../../assets/images/flag/gbr.jpg);
}

.flag .item.grc {
  background-image: url(../../../assets/images/flag/grc.jpg);
}

.flag .item.hun {
  background-image: url(../../../assets/images/flag/hun.jpg);
}

.flag .item.ind {
  background-image: url(../../../assets/images/flag/ind.jpg);
}

.flag .item.isr {
  background-image: url(../../../assets/images/flag/isr.jpg);
}

.flag .item.ita {
  background-image: url(../../../assets/images/flag/ita.jpg);
}

.flag .item.jpn {
  background-image: url(../../../assets/images/flag/jpn.jpg);
}

.flag .item.kaz {
  background-image: url(../../../assets/images/flag/kaz.jpg);
}

.flag .item.khm {
  background-image: url(../../../assets/images/flag/khm.jpg);
}

.flag .item.kor {
  background-image: url(../../../assets/images/flag/kor.jpg);
}

.flag .item.lao {
  background-image: url(../../../assets/images/flag/lao.jpg);
}

.flag .item.lka {
  background-image: url(../../../assets/images/flag/lka.jpg);
}

.flag .item.lux {
  background-image: url(../../../assets/images/flag/lux.jpg);
}

.flag .item.lva {
  background-image: url(../../../assets/images/flag/lva.jpg);
}

.flag .item.mar {
  background-image: url(../../../assets/images/flag/mar.jpg);
}

.flag .item.mex {
  background-image: url(../../../assets/images/flag/mex.jpg);
}

.flag .item.mlt {
  background-image: url(../../../assets/images/flag/mlt.jpg);
}

.flag .item.mmr {
  background-image: url(../../../assets/images/flag/mmr.jpg);
}

.flag .item.mng {
  background-image: url(../../../assets/images/flag/mng.jpg);
}

.flag .item.mus {
  background-image: url(../../../assets/images/flag/mus.jpg);
}

.flag .item.mys {
  background-image: url(../../../assets/images/flag/mys.jpg);
}

.flag .item.nga {
  background-image: url(../../../assets/images/flag/nga.jpg);
}

.flag .item.nld {
  background-image: url(../../../assets/images/flag/nld.jpg);
}

.flag .item.npl {
  background-image: url(../../../assets/images/flag/npl.jpg);
}

.flag .item.nzl {
  background-image: url(../../../assets/images/flag/nzl.jpg);
}

.flag .item.pak {
  background-image: url(../../../assets/images/flag/pak.jpg);
}

.flag .item.rou {
  background-image: url(../../../assets/images/flag/rou.jpg);
}

.flag .item.rus {
  background-image: url(../../../assets/images/flag/rus.jpg);
}

.flag .item.sgp {
  background-image: url(../../../assets/images/flag/sgp.jpg);
}

.flag .item.srb {
  background-image: url(../../../assets/images/flag/srb.jpg);
}

.flag .item.swe {
  background-image: url(../../../assets/images/flag/swe.jpg);
}

.flag .item.tha {
  background-image: url(../../../assets/images/flag/tha.jpg);
}

.flag .item.tza {
  background-image: url(../../../assets/images/flag/tza.jpg);
}

.flag .item.vnm {
  background-image: url(../../../assets/images/flag/vnm.jpg);
}

.start {
  position: absolute;
  width: 100%;
  bottom: 261px;
  text-align: center;
  opacity: 0;
  transition-duration: 1s;

  animation-iteration-count: infinite;
  animation-name: scale;
  animation-duration: 1s;
  animation-timing-function: linear;
}

.start.show {
  opacity: 1;
}

.start a {
  display: inline-block;
  /*background-image: url(../../../assets/images/letter/btn-bg.png);*/
  width: 188px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;
}

.start a.zh {
  background-image: url(../../../assets/images/letter/btns/zh.png);
}

.start a.de {
  background-image: url(../../../assets/images/letter/btns/de.png);
}

.start a.en {
  background-image: url(../../../assets/images/letter/btns/en.png);
}

.start a.es {
  background-image: url(../../../assets/images/letter/btns/es.png);
}

.start a.fr {
  background-image: url(../../../assets/images/letter/btns/fr.png);
}

.start a.ja {
  background-image: url(../../../assets/images/letter/btns/ja.png);
}

.start a.ko {
  background-image: url(../../../assets/images/letter/btns/ko.png);
}

.start a.ru {
  background-image: url(../../../assets/images/letter/btns/ru.png);
}

.start a span {
  display: block;
  margin-left: 10px;
  margin-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ns-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-position: center center;
  background-size: cover;
  background-image: url(../../../assets/images/letter/bg.jpg);
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
}

.letter-c {
  position: relative;
  width: 655px;
  height: 1080px;
}

.letter-c .quan {
  transform-origin: center center;
  position: absolute;
  left: 66px;
  top: 240px;
  background-image: url(../../../assets/images/letter/quan.png);
  width: 523px;
  height: 523px;
  animation-timing-function: linear;
  animation-name: rotate;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
}

.letter-c .text {
  text-align: center;
  color: #fff;
  font-size: 16px;
  width: 100%;
  position: absolute;
  left: 0px;
  top: 235px;
}


.letter-c .btn {

  opacity: 0;
  font-size: 16px;
  width: 188px;
  position: absolute;
  left: 233px;
  top: 700px;
  /*background-image: url(../../../assets/images/letter/btn-bg.png);*/
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;

  transition-duration: 0.3s;

  animation-iteration-count: infinite;
  animation-name: scale;
  animation-duration: 1s;
  animation-timing-function: linear;

}


.letter-c .btn.zh {
  background-image: url(../../../assets/images/letter/btns2/zh.png);
}

.letter-c .btn.de {
  background-image: url(../../../assets/images/letter/btns2/de.png);
}

.letter-c .btn.en {
  background-image: url(../../../assets/images/letter/btns2/en.png);
}

.letter-c .btn.es {
  background-image: url(../../../assets/images/letter/btns2/es.png);
}

.letter-c .btn.fr {
  background-image: url(../../../assets/images/letter/btns2/fr.png);
}

.letter-c .btn.ja {
  background-image: url(../../../assets/images/letter/btns2/ja.png);
}

.letter-c .btn.ko {
  background-image: url(../../../assets/images/letter/btns2/ko.png);
}

.letter-c .btn.ru {
  background-image: url(../../../assets/images/letter/btns2/ru.png);
}


.letter-c .btn.show {
  opacity: 1;
}

.letter-c .btn span {
  display: block;
  margin-left: 10px;
  margin-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.letter-c .bg.play {
  transform: scale(1);
  /*animation-iteration-count: infinite;*/
  animation-name: play-letter;
  animation-duration: 1.5s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  animation-timing-function: steps(1);
}

.letter-c .bg.show {
  transform: scale(1);
  animation-iteration-count: infinite;
  animation-name: upAndDown;
  animation-duration: 1.3s;
  animation-delay: 0.9s;
  animation-timing-function: linear;
}

.letter-c .bg {
  transform-origin: 335px 518px;
  position: absolute;
  transform: scale(0);
  transition-duration: 0.8s;
  transition-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-image: url(../../../assets/images/letter/sheet.png);
}

@keyframes upAndDown {
  0% {
    top: 0px;
  }
  25% {
    top: -5px;
  }
  75% {
    top: 5px;
  }
  100% {
    top: 0px
  }
}

@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes play-letter {
  0% {
    background-position: -0px -0px;
  }
  5.5555553% {
    background-position: -655px -0px;
  }
  11.111111% {
    background-position: -1310px -0px;
  }
  16.666666% {
    background-position: -1965px -0px;
  }
  22.222221% {
    background-position: -2620px -0px;
  }
  27.777777% {
    background-position: -3275px -0px;
  }
  33.333332% {
    background-position: -3930px -0px;
  }
  38.888885% {
    background-position: -4585px -0px;
  }
  44.444443% {
    background-position: -5240px -0px;
  }
  50% {
    background-position: -5895px -0px;
  }
  55.555553% {
    background-position: -0px -1080px;
  }
  61.111107% {
    background-position: -655px -1080px;
  }
  66.666664% {
    background-position: -1310px -1080px;
  }
  72.22222% {
    background-position: -1965px -1080px;
  }
  77.77777% {
    background-position: -2620px -1080px;
  }
  83.33333% {
    background-position: -3275px -1080px;
  }
  88.888885% {
    background-position: -3930px -1080px;
  }
  94.44444% {
    background-position: -4585px -1080px;
  }
  100% {
    background-position: -5240px -1080px;
  }
}

</style>

